(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Controller = App.loadClass('core::Angular/Controller');

  exports.BaseMachineryController = (function(superClass) {
    extend(BaseMachineryController, superClass);

    function BaseMachineryController(scope, transitions, modal, machineryService, q, viewing, editing, id1, typeId) {
      var unregister;
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.machineryService = machineryService;
      this.q = q;
      this.viewing = viewing;
      this.editing = editing;
      this.id = id1;
      this.typeId = typeId;
      this.openDialog = bind(this.openDialog, this);
      this.addRowSpacing = bind(this.addRowSpacing, this);
      this.addDisplayMakeModel = bind(this.addDisplayMakeModel, this);
      this.addMakeModel = bind(this.addMakeModel, this);
      this.filterSeedMeters = bind(this.filterSeedMeters, this);
      this.filterSubtypes = bind(this.filterSubtypes, this);
      this.loadMachineryData = bind(this.loadMachineryData, this);
      this.startEditing = bind(this.startEditing, this);
      this.dirtyCropAndFormat = bind(this.dirtyCropAndFormat, this);
      BaseMachineryController.__super__.constructor.call(this, this.scope, this.transitions);
      this.machineryForm = {};
      if (this.editing) {
        unregister = this.scope.$watch((function(_this) {
          return function() {
            return _this.machineryForm;
          };
        })(this), (function(_this) {
          return function(form) {
            if ((form.proprietary_format != null) && (_this.machinery.type.name !== 'Planter' || (form.crop != null))) {
              _this.dirtyCropAndFormat();
              return unregister();
            }
          };
        })(this), true);
      }
      this.scope.cancel = this.cancel.bind(this);
      this.subtypeFilters = {
        'Corn': ['Planter'],
        'Small Grains': ['Air Seeder', 'Planter', 'Drill', 'Broadcast'],
        'Soybeans': ['Air Seeder', 'Planter', 'Drill', 'Broadcast'],
        'Cotton': ['Planter']
      };
      this.seedMeterFilters = {
        'Air Seeder': ['Paddle'],
        'Broadcast': ['Paddle'],
        'Drill': ['Paddle'],
        'Planter': ['Air', 'Belt', 'Brush', 'Finger', 'Plate']
      };
      this.formData = {
        makes: [],
        models: [],
        subtypes: []
      };
      this.machinery = this.machineryService["new"]({
        type: null,
        insecticide: false,
        twin_rows: false,
        variable_rate: false,
        used_for_fertilizer: false
      });
      this.nicknameIsUnique = true;
      if (this.id != null) {
        this.machineryService.getType(this.typeId).then((function(_this) {
          return function(type) {
            _this.machinery.type = type;
            return _this.loadFormData(_this.id);
          };
        })(this));
      } else {
        this.machineryService.getTypes().then((function(_this) {
          return function(types) {
            return _this.types = types;
          };
        })(this));
      }
      this.scope.$watch('[emc.machinery.swath_width, emc.machinery.row_spacing]', (function(_this) {
        return function() {
          var ratio;
          if (_this.machinery.seed_meter !== 'Paddle') {
            return;
          }
          if (App.is_metric) {
            ratio = 100;
          } else {
            ratio = 12;
          }
          return _this.machinery.number_of_rows = Math.ceil((_this.machinery.swath_width * ratio) / _this.machinery.row_spacing);
        };
      })(this));
    }

    BaseMachineryController.prototype.dirtyCropAndFormat = function() {
      var ref, ref1;
      if ((ref = this.machineryForm.crop) != null) {
        ref.$setDirty();
      }
      return (ref1 = this.machineryForm.proprietary_format) != null ? ref1.$setDirty() : void 0;
    };

    BaseMachineryController.prototype.startEditing = function() {
      this.viewing = false;
      this.editing = true;
      if ((this.machineryForm.proprietary_format != null) && (this.machinery.type.name !== 'Planter' || (this.machineryForm.crop != null))) {
        return this.dirtyCropAndFormat();
      }
    };

    BaseMachineryController.prototype.loadFormData = function(id) {
      if (id == null) {
        id = null;
      }
      return this.machineryService.getFormData(this.machinery).then((function(_this) {
        return function(data) {
          angular.extend(_this.formData, data);
          _this.clearAlert();
          return _this.loadMachineryData(id).then(function() {
            _this.machineryService.getSubtypes(_this.machinery.type).then(function(subtypes) {
              return _this.formData.subtypes = subtypes;
            });
            if (id == null) {
              return;
            }
            if (_this.machinery.subtype) {
              _this.machineryService.getMakes(_this.machinery.type, _this.machinery.subtype).then(function(makes) {
                return _this.formData.makes = makes;
              });
              if (_this.machinery.make) {
                _this.machineryService.getModels(_this.machinery.type, _this.machinery.subtype, _this.machinery.make).then(function(models) {
                  return _this.formData.models = models;
                });
              }
              if (_this.machinery.variable_rate) {
                _this.machineryService.getControllerMakes().then(function(makes) {
                  return _this.formData.controllerMakes = makes;
                });
                _this.machineryService.getControllerModels(_this.machinery.controller_make).then(function(models) {
                  return _this.formData.controllerModels = models;
                });
                return _this.machineryService.getProprietaryFormats(_this.machinery.controller_make, _this.machinery.controller_model).then(function(formats) {
                  return _this.formData.proprietaryFormats = formats;
                });
              }
            }
          });
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          console.error(error);
          if (error instanceof Error) {
            return _this.setAlert({
              msg: error.toString(),
              type: 'error'
            }, [error.stack]);
          } else {
            return _this.setAlert({
              msg: error.statusText,
              type: 'error'
            });
          }
        };
      })(this));
    };

    BaseMachineryController.prototype.loadMachineryData = function(id) {
      if (id == null) {
        id = null;
      }
      if (id != null) {
        return this.machineryService.getMachinery(this.machinery.type, id).then((function(_this) {
          return function(machinery) {
            _this.clearAlert();
            return _this.machinery = machinery;
          };
        })(this));
      } else {
        this.machinery.insecticide = false;
        this.machinery.twin_rows = false;
        this.machinery.variable_rate = false;
        this.machinery.used_for_fertilizer = false;
        return this.q.resolve();
      }
    };

    BaseMachineryController.prototype.save = function() {
      this.setAlert({
        msg: 'Saving machinery...',
        type: 'info'
      });
      return this.machineryService.save(this.machinery).then((function(_this) {
        return function(machine) {
          return _this.setAlert({
            msg: _this.machinery.type.name + " saved!",
            type: 'success'
          });
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          return _this.setAlert({
            msg: error,
            type: 'error'
          });
        };
      })(this));
    };

    BaseMachineryController.prototype.cancel = function() {
      return void 0;
    };

    BaseMachineryController.prototype.onTypeChange = function() {
      this.machinery = this.machineryService["new"]({
        type: this.machinery.type,
        insecticide: false,
        twin_rows: false,
        variable_rate: false,
        used_for_fertilizer: false
      });
      if (this.machinery.type != null) {
        return this.loadFormData().then((function(_this) {
          return function() {
            var ref;
            return (ref = _this.machineryForm.subtype) != null ? ref.$setPristine() : void 0;
          };
        })(this));
      }
    };

    BaseMachineryController.prototype.onCropChange = function() {
      this.machinery.subtype = this.machinery.make = this.machinery.model = this.machinery.seed_meter = null;
      this.machineryForm.subtype.$setPristine();
      this.machineryForm.make.$setPristine();
      return this.machineryForm.model.$setPristine();
    };

    BaseMachineryController.prototype.validateNickname = function(name) {
      return this.machineryService.validateNickname(this.machinery, name);
    };

    BaseMachineryController.prototype.onSubtypeChange = function(val) {
      if (this.machinery.type.name === 'Planter') {
        this.machinery.seed_meter = null;
      }
      this.machinery.fertilizer_source_type = this.machinery.make = this.machinery.model = null;
      this.machineryForm.make.$setPristine();
      this.machineryForm.model.$setPristine();
      if (this.machinery.subtype == null) {
        return;
      }
      if (this.machinery.subtype) {
        return this.machineryService.getMakes(this.machinery.type, this.machinery.subtype).then((function(_this) {
          return function(makes) {
            return _this.formData.makes = makes;
          };
        })(this));
      }
    };

    BaseMachineryController.prototype.onMakeChange = function() {
      this.machinery.model = null;
      this.machineryForm.model.$setPristine();
      if (this.machinery.make == null) {
        return;
      }
      return this.machineryService.getModels(this.machinery.type, this.machinery.subtype, this.machinery.make).then((function(_this) {
        return function(models) {
          return _this.formData.models = models;
        };
      })(this));
    };

    BaseMachineryController.prototype.onVariableRateChange = function() {
      this.machinery.controller_make = null;
      this.machineryForm.display_make.$setPristine();
      this.onControllerMakeChange();
      if (!this.machinery.variable_rate) {
        return;
      }
      return this.machineryService.getControllerMakes().then((function(_this) {
        return function(makes) {
          return _this.formData.controllerMakes = makes;
        };
      })(this));
    };

    BaseMachineryController.prototype.onControllerMakeChange = function() {
      this.machinery.controller_model = null;
      this.machinery.rx_naming_format = null;
      this.machineryForm.display_model.$setPristine();
      this.machineryForm.proprietary_format.$setPristine();
      if (this.machinery.controller_make == null) {
        return;
      }
      return this.machineryService.getControllerModels(this.machinery.controller_make).then((function(_this) {
        return function(models) {
          _this.formData.controllerModels = models;
          if (models.length === 1) {
            _this.machinery.controller_model = models[0];
            return _this.onControllerModelChange();
          }
        };
      })(this));
    };

    BaseMachineryController.prototype.onControllerModelChange = function() {
      this.machinery.rx_naming_format = null;
      this.machineryForm.proprietary_format.$setPristine();
      if (this.machinery.controller_model == null) {
        return;
      }
      return this.machineryService.getProprietaryFormats(this.machinery.controller_make, this.machinery.controller_model).then((function(_this) {
        return function(formats) {
          _this.formData.proprietaryFormats = formats;
          if (formats.length === 1) {
            return _this.machinery.rx_naming_format = formats[0];
          }
        };
      })(this));
    };

    BaseMachineryController.prototype.filterSubtypes = function(thing) {
      var ref, ref1;
      if (((ref = this.machinery.type) != null ? ref.name : void 0) === 'Planter' && (this.machinery.crop != null)) {
        return ref1 = thing.name, indexOf.call(this.subtypeFilters[this.machinery.crop.name], ref1) >= 0;
      }
      return true;
    };

    BaseMachineryController.prototype.filterSeedMeters = function(thing) {
      var ref;
      if (((ref = this.machinery.type) != null ? ref.name : void 0) === 'Planter' && (this.machinery.subtype != null)) {
        return indexOf.call(this.seedMeterFilters[this.machinery.subtype.name], thing) >= 0;
      }
      return true;
    };

    BaseMachineryController.prototype.addMake = function(makeName) {
      this.machinery.make = null;
      this.machinery.model = null;
      this.formData.models = [];
      return this.addMakeModel(makeName, '');
    };

    BaseMachineryController.prototype.addModel = function(modelName) {
      this.machinery.model = null;
      return this.addMakeModel('', modelName);
    };

    BaseMachineryController.prototype.addMakeModel = function(makeName, modelName) {
      var newscope, parent;
      newscope = this.scope.$new(true);
      newscope.make = this.machinery.make || new this.machineryService.Make({
        name: makeName
      });
      newscope.make.subtype = this.machinery.subtype;
      newscope.make.subtype.type = this.machinery.type;
      newscope.model = new this.machineryService.Model({
        name: modelName,
        make: newscope.make
      });
      newscope.title = 'Add Make/Model';
      newscope.type = '';
      newscope.saveText = 'Save';
      newscope.validateMake = (function(_this) {
        return function(name) {
          if (!name || newscope.make.id) {
            return true;
          }
          return _this.machineryService.validateMake(_this.machinery.type, _this.machinery.subtype, name);
        };
      })(this);
      newscope.validateModel = (function(_this) {
        return function(name) {
          if (!name || (newscope.make.id == null)) {
            return true;
          }
          return _this.machineryService.validateModel(_this.machinery.type, _this.machinery.subtype, _this.machinery.make, name);
        };
      })(this);
      parent = this;
      newscope.saveMakeModel = function() {
        var makePromise;
        this.setAlert({
          msg: 'Saving...',
          type: 'info'
        });
        makePromise = Promise.resolve(newscope.make);
        if (newscope.make.id == null) {
          makePromise = parent.machineryService.saveMake(newscope.make).then((function(_this) {
            return function(make) {
              parent.formData.makes.push(make);
              parent.machinery.make = make;
              return parent.machineryForm.make.$setDirty();
            };
          })(this))["catch"]((function(_this) {
            return function(error) {
              return _this.setAlert({
                type: 'error',
                msg: error
              });
            };
          })(this));
        }
        return makePromise.then((function(_this) {
          return function() {
            return parent.machineryService.saveModel(newscope.model).then(function(model) {
              parent.formData.models.push(model);
              parent.machinery.model = model;
              parent.machineryForm.model.$setDirty();
              return _this.closeWithAlert({
                type: 'success',
                msg: 'Make/Model created successfully.'
              });
            })["catch"](function(error) {
              return _this.setAlert({
                type: 'error',
                msg: error
              });
            });
          };
        })(this));
      };
      return this.openDialog(newscope, 'backend/grower/machinery/layout-add-make-model');
    };

    BaseMachineryController.prototype.addDisplayMakeModel = function() {
      var newscope, parent;
      newscope = this.scope.$new(true);
      newscope.make = this.machinery.controller_make || new this.machineryService.ControllerMake({
        name: ''
      });
      newscope.model = new this.machineryService.ControllerModel({
        name: '',
        controller_make: newscope.make
      });
      newscope.title = 'Request Display Support';
      newscope.type = 'Display';
      newscope.saveText = 'Submit';
      newscope.text = 'To send MyFarms an email requesting support for a display that is not currently available, please fill out this form and click Submit.';
      newscope.validateMake = newscope.validateModel = (function(_this) {
        return function(name) {
          return true;
        };
      })(this);
      parent = this;
      newscope.saveMakeModel = function() {
        this.setAlert({
          msg: 'Saving...',
          type: 'info'
        });
        return parent.machineryService.requestController(newscope.make, newscope.model).then((function(_this) {
          return function() {
            return _this.closeWithAlert({
              type: 'success',
              msg: 'Your request has been successfully submitted for future consideration.'
            });
          };
        })(this))["catch"]((function(_this) {
          return function(error) {
            return _this.setAlert({
              type: 'error',
              msg: error
            });
          };
        })(this));
      };
      return this.openDialog(newscope, 'backend/grower/machinery/layout-add-make-model');
    };

    BaseMachineryController.prototype.addRowSpacing = function(rowSpacing) {
      var newscope, parent;
      newscope = this.scope.$new(true);
      newscope.title = 'Add Row Spacing';
      newscope.rowSpacing = new this.machineryService.RowSpacing({
        width: parseInt(rowSpacing)
      });
      newscope.validateRowSpacing = (function(_this) {
        return function(width) {
          return _this.machineryService.validateRowSpacing(width);
        };
      })(this);
      parent = this;
      newscope.saveRowSpacing = function() {
        this.setAlert({
          msg: 'Saving Model...',
          type: 'info'
        });
        return parent.machineryService.createRowSpacing(newscope.rowSpacing).then((function(_this) {
          return function(rowSpacing) {
            parent.formData.rowSpacings.push(rowSpacing.formatted_width);
            parent.machinery.row_spacing = rowSpacing.formatted_width;
            parent.machineryForm.row_spacing.$setDirty();
            return _this.closeWithAlert({
              type: 'success',
              msg: 'Row Spacing created successfully.'
            });
          };
        })(this))["catch"]((function(_this) {
          return function(error) {
            return _this.setAlert({
              type: 'error',
              msg: error
            });
          };
        })(this));
      };
      return this.openDialog(newscope, 'backend/grower/machinery/layout-add-row-spacing');
    };

    BaseMachineryController.prototype.openDialog = function(newscope, url) {
      var dlg;
      newscope.name = '';
      return dlg = this.modal.open({
        templateUrl: url,
        controller: 'DialogController',
        windowClass: 'small_dialog',
        scope: newscope
      });
    };

    return BaseMachineryController;

  })(Controller);

}).call(this);
